import { useCallback, useEffect, useState } from "react";
import { api } from "../../api/client";

export default function AdminAnnouncementsPage() {
  const [announcements, setAnnouncements] = useState<any[]>([]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [creating, setCreating] = useState(false);

  const load = useCallback(async () => { try { setAnnouncements(await api.get("/api/announcements")); } catch {} }, []);
  useEffect(() => { void load(); }, [load]);

  const create = async () => {
    if (!title.trim() || !content.trim()) return;
    setCreating(true);
    try { await api.post("/api/announcements", { title: title.trim(), content: content.trim(), publish_now: true }); setTitle(""); setContent(""); await load(); } catch {} finally { setCreating(false); }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-gray-900">Announcements</h1>
      <div className="rounded-xl border border-gray-200 bg-white p-4 space-y-3">
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" className="input" />
        <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="Content..." rows={3} className="input" />
        <button type="button" onClick={create} disabled={creating} className="rounded-lg bg-pme-blue px-4 py-2 text-sm font-semibold text-white disabled:opacity-60">Publish</button>
      </div>
      {announcements.map((a: any) => (
        <div key={a.id} className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex items-start justify-between gap-2">
            <div><p className="text-sm font-semibold text-gray-900">{a.title}</p><p className="mt-1 text-xs text-gray-600">{a.content.slice(0, 200)}</p></div>
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${a.priority === "urgent" ? "bg-red-50 text-red-700" : a.priority === "important" ? "bg-amber-50 text-amber-800" : "bg-gray-100 text-gray-600"}`}>{a.priority}</span>
          </div>
          <p className="mt-1 text-[10px] text-gray-400">{a.published_at ? new Date(a.published_at).toLocaleString() : "Draft"}</p>
        </div>
      ))}
    </div>
  );
}
